import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { ThemeColor } from "../../theme/palette";
import { DRIP_SEGMENT_ACTIVE_BG, DRIP_TEXT_MUTED, DRIP_TRACK_BG } from "./dripStyles";

interface DripSegmentTabsProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export const DripSegmentTabs = ({ tabs, activeIndex, onChange }: DripSegmentTabsProps) => (
  <Box
    role="tablist"
    bg={DRIP_TRACK_BG}
    borderRadius="xl"
    border="1px solid"
    borderColor="whiteAlpha.200"
    p="3px"
    width="100%"
  >
    <Flex gap="3px">
      {tabs.map((label, index) => {
        const isActive = activeIndex === index;
        return (
          <Button
            key={label}
            role="tab"
            type="button"
            aria-selected={isActive}
            flex={1}
            variant="unstyled"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="lg"
            py={2.5}
            px={2}
            minH="40px"
            bg={isActive ? DRIP_SEGMENT_ACTIVE_BG : "transparent"}
            boxShadow={isActive ? "inset 0 0 0 1px rgba(95, 244, 244, 0.35)" : "none"}
            transition="background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease"
            onClick={() => onChange(index)}
            _hover={{ bg: isActive ? DRIP_SEGMENT_ACTIVE_BG : "whiteAlpha.100" }}
            _focusVisible={{ boxShadow: "0 0 0 2px rgba(95, 244, 244, 0.5)" }}
          >
            <Text
              fontSize="sm"
              fontWeight={isActive ? "semibold" : "medium"}
              color={isActive ? ThemeColor.KAIROS : DRIP_TEXT_MUTED}
              letterSpacing="0.01em"
              noOfLines={1}
            >
              {label}
            </Text>
          </Button>
        );
      })}
    </Flex>
  </Box>
);
